import { render, staticRenderFns } from "./fieldMultiInput.vue?vue&type=template&id=04d7585a&scoped=true&"
import script from "./fieldMultiInput.vue?vue&type=script&lang=js&"
export * from "./fieldMultiInput.vue?vue&type=script&lang=js&"
import style0 from "./fieldMultiInput.vue?vue&type=style&index=0&id=04d7585a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7585a",
  null
  
)

export default component.exports